// src/App.js
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import AuthWrapper from "./Components/AuthWrapper";
import PrivateRoute from "./Components/PrivateRoute";

// Páginas Públicas
import Login from "./Pages/Auth/Login";
import ForgotPassword from "./Pages/Auth/ForgotPassword";
import ResetPassword from "./Pages/Auth/ResetPassword";
import Register from "./Pages/Auth/Register";
import DriverRegister from "./Pages/Auth/DriverRegister";
import CarrierRegister from "./Pages/Auth/CarrierRegister";
import UserRegister from "./Pages/Auth/UserRegister";
import AcceptInvite from "./Pages/Auth/AcceptInvite";
import RemoteSignature from "./Pages/Load/RemoteSignature";

// Páginas Privadas
import Dashboard from "./Pages/Dashboard";
import Loads from "./Pages/Load/Loads";
import CreateLoad from "./Pages/Load/CreateLoad";
import Inspection from "./Pages/Load/Inspection";
import CreateQuote from "./Pages/Quote/CreateQuote";
import Quotes from "./Pages/Quote/Quotes";
import Employees from "./Pages/Employee/Employees";
import Shippers from "./Pages/Shipper/Shippers";
import ExternalLoad from "./Pages/Finance/ExternalLoad"
import NewExternalLoad from "./Pages/Finance/NewExternalLoad"
import DriverExpense from "./Pages/Finance/DriverExpense"
import Report from "./Pages/Finance/Report"
import NewDriverExpense from "./Pages/Finance/NewDriverExpense"
import LoadPublicDetails from "./Pages/Load/LoadPublicDetails";
import InspectionGallery from "./Pages/Load/InspectionGallery";
import CompanyPublicProfile from "./Pages/Company/CompanyPublicProfile";
import CompanyManagement from "./Pages/Company/CompanyManagement";
import LandingPageManagement from "./Pages/Company/LandingPageManagement";
import Factoring from "./Pages/Factoring/Factoring";
import InspectionPhotoHierarchy from "./Pages/Maintenance/InspectionPhotoHierarchy";
import UserAccessLogs from "./Pages/Maintenance/UserAccessLogs";
import LoadTransportMaintenance from "./Pages/Maintenance/LoadTransportMaintenance";
import Lead from "./Pages/Lead/Lead"
import CarrierLead from "./Pages/CarrierLead/CarrierLead"

function App() {
  return (
    <Router>
      <AuthProvider>
        {/* Mantém o wrapper antigo para preservar estilo/layout */}
        <AuthWrapper>
          <Routes>
            {/** ROTAS PRIVADAS **/}
            <Route path="/" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/dashboard" element={<PrivateRoute element={<Dashboard />} />} />
            <Route path="/load" element={<PrivateRoute element={<Loads />} />} />
            <Route path="/newload" element={<PrivateRoute element={<CreateLoad />} />} />
            <Route path="/inspectionloaditem" element={<PrivateRoute element={<Inspection />} />} />
            <Route path="/newquotes" element={<PrivateRoute element={<CreateQuote />} />} />
            <Route path="/quotes" element={<PrivateRoute element={<Quotes />} />} />
            <Route path="/shippermanagement" element={<PrivateRoute element={<Shippers />} />} />
            <Route path="/landingpagemanagement" element={<PrivateRoute element={<LandingPageManagement />} />} />
            <Route path="/companymanagement" element={<PrivateRoute element={<CompanyManagement />} />} />
            <Route path="/staffmanagement" element={<PrivateRoute element={<Employees />} />} />
            <Route path="/externalload" element={<PrivateRoute element={<ExternalLoad />} />} /> {/* renomear para "/externalload" / <ExternalLoad /> */}
            <Route path="/newexternalload" element={<PrivateRoute element={<NewExternalLoad />} />} /> {/* renomear para "/newexternalload" / <NewExternalLoad /> */}
            <Route path="/expense" element={<PrivateRoute element={<DriverExpense />} />} />
            <Route path="/newexpense" element={<PrivateRoute element={<NewDriverExpense />} />} />
            <Route path="/report" element={<PrivateRoute element={<Report />} />} />
            <Route path="/factoring" element={<PrivateRoute element={<Factoring />} />} />
            <Route path="/InspectionPhotoHierarchy" element={<InspectionPhotoHierarchy />} />
            <Route path="/UserAccessLogs" element={<UserAccessLogs />} />
            <Route path="/LoadTransportMaintenance" element={<LoadTransportMaintenance />} />
            <Route path="/lead" element={<PrivateRoute element={<Lead />} />} />
            <Route path="/carrier-leads" element={<PrivateRoute element={<CarrierLead />} />} />
            {/* <Route path="/loads/public" element={<PrivateRoute element={<LoadPublicDetails />} />} />
            <Route path="/inspectiongallery" element={<PrivateRoute element={<InspectionGallery />} />} /> */}

            {/** ROTAS PÚBLICAS **/}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register/driver" element={<DriverRegister />} />
            <Route path="/register/carrier" element={<CarrierRegister />} />
            <Route path="/register/user" element={<UserRegister />} />

            {/* NOVA ROTA */}
            <Route path="/accept-invite" element={<AcceptInvite />} />

            <Route path="/loads/public/:id" element={<LoadPublicDetails />} />
            <Route path="/inspectiongallery/:loadItemId/:inspectionType" element={<InspectionGallery />} />
            <Route path="/company/public/:id" element={<CompanyPublicProfile />} />
            <Route path="/remote-signature/:token" element={<RemoteSignature />} />

            {/** Catch-all: redireciona para a dashboard **/}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthWrapper>
      </AuthProvider>
    </Router>
  );
}

export default App;
